import DeleteBarcodeModal from './DeleteBarcodeModal'

export default DeleteBarcodeModal
